import { COLUMNS } from '../_constants/Columns'

export default {
  getDefaultState: () => {
    return {
      newExpense: undefined,
      transactions: [],
      users: [],
      filters: {},
      userSelectedFiltersAmount: 0,
      currentPage: 1,
      lastPage: 1,
      totalItems: 0,
      currentTransaction: {
        type: {
          code: 'EXPENSE'
        },
        receipt: {}
      },
      currentTransactionSelectedBudgetTagTypes: [],
      isLoadingTransactions: false,
      isLoadingNextPageTransactions: false,
      userPaymentMethods: [],
      officePaymentMethods: [],
      userPaymentMethodsFilters: {},
      currentExpenseReceipts: [],
      selectAllFlag: false,
      selectedTransactionsBulkAction: false,
      selectedTransactions: [],
      selectedUsersBulkAction: false,
      selectedUsers: [],
      transactionDashboard: null,
      transactionsWithoutFiltersDashboard: null,
      topBanner: null,
      isCallingTransactionDashboard: false,
      isCallingTransactionDashboardWithoutFilters: false,
      receiptModalIsOpen: false,
      transactionReviewBarIsShown: true,
      transactionMissingInfoBarIsShown: true,
      receiptUploadingByDragAndDrop: false,
      vatTypes: [],
      /// Used to get data according to section
      expenses: false,
      tableColumns: COLUMNS.TRANSACTIONS_LIST,
      tableUsersColumns: COLUMNS.USERS_LIST,
      tableExportColumns: COLUMNS.EXPORT_LIST,
      /// Users list
      usersCurrentPage: 1,
      usersLastPage: 1,
      usersTotalItems: 0,
      // Filtered view
      filteredViews: [],
      filteredViewBaseId: 1,
      currentFilteredView: {}

    }
  }
}
